<script lang="ts">
  import { isAuthenticated, project } from "$lib/services/store";
  import { loginAuth0, logoutAuth0 } from "$lib/services/auth0";
  import Icons from "$lib/main/components/Icons.svelte";
  import Translate from "$lib/admin/components/blocks/helpers/Translate.svelte";
  import { Dropdown, DropdownItem } from "flowbite-svelte";

  export let isMobile: boolean = false;

  async function login() {
    if (typeof window !== "undefined") {
      const tournamentRoute = $project.settings.tournamentsUrl ?? "turneringar";
      const redirectPathName = window.location.pathname.includes(`/${tournamentRoute}`)
        ? `/${tournamentRoute}`
        : "/profile";
      await loginAuth0(redirectPathName);
    }
  }

  async function signup() {
    const tournamentRoute = $project.settings.tournamentsUrl ?? "turneringar";
    await loginAuth0(`/${tournamentRoute}`, "signup");
  }

  async function logout() {
    logoutAuth0();
  }
</script>

{#if isMobile}
  <!-- Mobile login buttons -->
  <div class="flex flex-col gap-4 px-6 mt-6 md:hidden">
    {#if $isAuthenticated}
      <a
        href="/profile"
        class="px-2 py-2 w-full text-base font-bold text-center text-white bg-transparent rounded-full border border-white hover:text-white">
        <Translate text="Profile" />
      </a>
      <button
        on:click={() => logout()}
        class="px-2 py-2 w-full text-base font-bold text-center bg-white rounded-full text-brand-light">
        <Translate text="Log out" />
      </button>
    {:else}
      <button
        on:click={() => login()}
        class="px-2 py-2 w-full text-base font-bold text-center bg-white rounded-full text-brand-light">
        <Translate text="Log in" />
      </button>
      <button
        on:click={() => signup()}
        class="px-2 py-2 w-full text-base font-bold text-center text-white bg-transparent rounded-full border border-white">
        <Translate text="Sign up" />
      </button>
    {/if}
  </div>
{:else}
  <!-- Desktop login/user menu -->
  <div class="flex md:block">
    {#if $isAuthenticated}
      <div class="relative inline-block">
        <button class="user-menu-button flex items-center text-sm font-bold text-white hover:text-gray-200">
          <Icons name="user" width="20px" height="20px" fill="currentColor" color="currentColor" />
          <span class="hidden md:block ml-1"><Translate text="Profile" /></span>
        </button>
        <Dropdown class="w-44 z-50 rounded-sm rounded-tl-none" triggeredBy=".user-menu-button">
          <DropdownItem href="/profile" class="flex items-center hover:bg-brand-light hover:text-white text-black">
            <Icons name="user" width="20px" height="20px" class="mr-2" />
            <span><Translate text="Edit profile" /></span>
          </DropdownItem>
          <DropdownItem on:click={logout} class="flex items-center hover:bg-brand-light hover:text-white text-black">
            <Icons name="log-out" width="20px" height="20px" class="mr-2" />
            <span><Translate text="Log out" /></span>
          </DropdownItem>
        </Dropdown>
      </div>
    {:else}
      <a
        href="/"
        on:click|preventDefault={login}
        class="flex items-center text-sm font-bold text-white hover:text-gray-200">
        <Icons name="user" width="20px" height="20px" fill="currentColor" color="currentColor" />
        <span class="hidden md:block ml-1"><Translate text="Log in" /></span>
      </a>
    {/if}
  </div>
{/if}
